/* PDP Buy Now state manager
   - Subscribes to variantChange events and applies a disabled visual/semantic state
     to the `.shopify-payment-button` wrapper when the selected variant is unavailable
     or the server indicates the add-to-cart button is disabled.
   - Scope: per `product-form[data-section-id]` instances.
*/
(function () {
  if (typeof subscribe !== 'function') return;

  function applyStateToWrapper(productFormEl, disabled) {
    if (!productFormEl) return;
    const wrapper = productFormEl.querySelector('.shopify-payment-button');
    if (!wrapper) return;

    if (disabled) {
      wrapper.classList.add('is-disabled');
      try { wrapper.setAttribute('aria-disabled', 'true'); } catch (e) {}

      const candidates = wrapper.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__button--unbranded, [role="button"], button');
      candidates.forEach((el) => {
        try {
          // Don't try to set disabled inside iframes or on elements that contain iframes
          if (el.querySelector && el.querySelector('iframe')) return;
          if (el.tagName === 'BUTTON') el.setAttribute('disabled', 'disabled');
          el.setAttribute('aria-disabled', 'true');
        } catch (e) {}
      });
    } else {
      wrapper.classList.remove('is-disabled');
      try { wrapper.removeAttribute('aria-disabled'); } catch (e) {}
      const candidates = wrapper.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__button--unbranded, [role="button"], button');
      candidates.forEach((el) => {
        try {
          if (el.tagName === 'BUTTON') el.removeAttribute('disabled');
          el.removeAttribute('aria-disabled');
        } catch (e) {}
      });
    }
  }

  function computeDisabledFromHtml(html, sectionId, variant) {
    try {
      if (!html) {
        // fallback to variant availability
        return !variant || variant.available === false;
      }
      const serverButton = html.getElementById(`ProductSubmitButton-${sectionId}`) || html.querySelector('.product-form__submit');
      const serverDisabled = serverButton ? serverButton.hasAttribute('disabled') : false;
      // Also consider missing variant as disabled
      if (!variant) return true;
      return serverDisabled || variant.available === false;
    } catch (e) {
      return !variant || variant.available === false;
    }
  }

  function handleVariantChange({ data }) {
    if (!data) return;
    const sectionId = data.sectionId;
    const variant = data.variant;
    const html = data.html;

    const disabled = computeDisabledFromHtml(html, sectionId, variant);

    // Find any product-form instances for this section id
    const forms = Array.from(document.querySelectorAll('product-form')).filter((f) => {
      try { return f.dataset && (f.dataset.sectionId === String(sectionId) || f.dataset.section === String(sectionId)); } catch (e) { return false; }
    });

    forms.forEach((form) => applyStateToWrapper(form, disabled));
  }

  // Initial pass for product-forms present on load
  function initialPass() {
    Array.from(document.querySelectorAll('product-form')).forEach((form) => {
      try {
        const sectionId = form.dataset ? form.dataset.sectionId || form.dataset.section : null;
        const serverButton = form.querySelector(`#ProductSubmitButton-${sectionId}`) || form.querySelector('.product-form__submit');
        const serverDisabled = serverButton ? serverButton.hasAttribute('disabled') : false;
        applyStateToWrapper(form, serverDisabled);
      } catch (e) {}
    });
  }

  try {
    // subscribe to variantChange events published by product-info
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  } catch (e) {}

  // Also listen for legacy DOM event in case other scripts dispatch it
  document.addEventListener('variant:change', (evt) => {
    try {
      const detail = evt.detail || {};
      // support both forms: { variant } or { variant, sectionId }
      handleVariantChange({ data: { sectionId: detail.sectionId || detail.section, variant: detail.variant, html: null } });
    } catch (e) {}
  });

  // Run initial pass after a small timeout to allow server-rendered DOM to settle
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(initialPass, 20));
  } else {
    setTimeout(initialPass, 20);
  }
})();
